function ensureContainer(position) {
  let container = document.querySelector(`.toasted-container.${position}`);
  if (container) return container;

  container = document.createElement('div');
  container.className = `toasted-container ${position}`;
  Object.assign(container.style, {
    position: 'fixed',
    zIndex: '999999',
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem',
    pointerEvents: 'none',
  });

  if (position.includes('top')) {
    container.style.top = '1rem';
  } else {
    container.style.bottom = '1rem';
  }

  if (position.includes('center')) {
    container.style.left = '50%';
    container.style.transform = 'translateX(-50%)';
  } else if (position.includes('right')) {
    container.style.right = '1rem';
  } else {
    container.style.left = '1rem';
  }

  document.body.appendChild(container);
  return container;
}

function createToast(message, type, options) {
  const container = ensureContainer(options.position);
  const toast = document.createElement('div');
  toast.className = `toasted toasted-primary ${type} ${options.className ?? ''}`.trim();
  toast.textContent = message;

  Object.assign(toast.style, {
    minWidth: '220px',
    maxWidth: 'min(420px, calc(100vw - 2rem))',
    padding: '0.85rem 1.15rem',
    borderRadius: '0.35rem',
    boxShadow: '0 0.35rem 1rem rgba(0, 0, 0, 0.25)',
    color: '#fff',
    fontWeight: '600',
    pointerEvents: 'auto',
    opacity: '1',
    transition: 'opacity 180ms ease, transform 180ms ease',
    transform: 'translateY(0)',
    background: type === 'error' ? '#fd397a' : 'var(--primary)',
  });

  container.appendChild(toast);

  const api = {
    el: toast,
    goAway(delay = 0) {
      setTimeout(() => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateY(-0.35rem)';
        setTimeout(() => toast.remove(), 180);
      }, delay);
    },
  };

  if (options.duration !== null && options.duration !== false) {
    api.goAway(options.duration ?? 2000);
  }

  return api;
}

export default {
  install(app, options = {}) {
    const defaults = {
      position: 'top-center',
      className: 'alert',
      duration: 2000,
      ...options,
    };

    const toasted = {
      show(message, toastOptions = {}) {
        return createToast(message, 'info', { ...defaults, ...toastOptions });
      },
      success(message, toastOptions = {}) {
        return createToast(message, 'success', { ...defaults, ...toastOptions });
      },
      error(message, toastOptions = {}) {
        return createToast(message, 'error', { ...defaults, ...toastOptions });
      },
      info(message, toastOptions = {}) {
        return createToast(message, 'info', { ...defaults, ...toastOptions });
      },
      clear() {
        document.querySelectorAll('.toasted-container .toasted').forEach((toast) => toast.remove());
      },
      goAway(delay = 0) {
        document.querySelectorAll('.toasted-container .toasted').forEach((toast) => {
          setTimeout(() => toast.remove(), delay);
        });
      },
    };

    app.config.globalProperties.$toasted = toasted;
  },
};
